import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SaleContract } from '../sale-contracts/sale-contract.model';
import { BaseGridComponent } from 'projects/libraries/syslink-components/src/lib/grid/base-grid/base-grid.component';
import { ContextMenuItemAction } from 'projects/libraries/syslink-components/src/lib/context-menus/context-menu-item-action';
import { SyslinkColumn } from 'projects/libraries/syslink-components/src/lib/helpers/SyslinkColumn';
import { SaleContractsService } from '../sale-contracts/sale-contracts.service';
import { DXCell } from 'projects/libraries/syslink-components/src/lib/grid/cells/dxcell';

@Component({
  selector: 'app-sale-contract-grid',
  templateUrl: './sale-contract-grid.component.html',
  styleUrls: ['./sale-contract-grid.component.scss']
})
export class SaleContractGridComponent extends BaseGridComponent<SaleContract> {
  @Input() override detailsUrl: string = '/sales/contracts';
  @Input() override storageKey: string = 'sale-contracts';
  @Input() public contextMenuItems: ContextMenuItemAction[] = [];
  @Input() showPager: boolean = true;
  @Input() items?: any[];

  // FilterValue
  // -----------
  @Output() onFilterValueChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  public columns: SyslinkColumn[] = [
    new SyslinkColumn({ field: "No", label: "GRID.CAPTION.NO", width: 150, sortIndex: 2, sortDirection: 'desc' }),
    new SyslinkColumn({ field: "ThirdId.Fullname", label: "Customer", width: 250 }),
    new SyslinkColumn({ field: "Subject", label: "Subject" }),
    new SyslinkColumn({ field: "CurrentStatusLink.StatusId.Name", label: "Status", cellTemplate: 'statusText-cell', data: { getStatusLabel: this.getStatusCellLabel, getStatusDate: this.getStatusCellDate, getStatusClass: this.getStatusCellClass, getStatusColor: this.getStatusCellColor }, width: 120 }),
    new SyslinkColumn({ field: "RRule", label: "Repeat", visible: true, cellTemplate: 'rrule-cell' }),
    new SyslinkColumn({ field: "GenerateDocumentNextDate", label: "GenerateDocumentNextDate", type: 'date', cellTemplate: 'date-cell', visible: true, width: 110, filterable: false, sortable: false, headerFilterable: false }),
    new SyslinkColumn({ field: "ExternalReference", label: "External reference", visible: true, width: 150 }),
    new SyslinkColumn({ field: "Deadline", label: "SaleContract.Validity", type: 'date', width: 110 }),
    new SyslinkColumn({ field: "ResponsibleUserId.Fullname", label: "Responsible", width: 120 }),
    new SyslinkColumn({ field: "CurrentStatusLink.StatusId.Sequence", label: 'status order', sortIndex: 1, sortDirection: 'asc', filterable: false, headerFilterable: false, width: 0, visible: false })
  ];

  @Input() public override expand?: string | string[] = ['CurrentStatusLink.StatusId'];
  @Input() public override select?: string[] = ['Id', 'No', 'ThirdId.Fullname', 'Subject', 'RRule', 'GenerateDocumentNextDate', 'Deadline', 'ExternalReference', 'ResponsibleUserId.Fullname'];


  constructor(
    public saleContractsService: SaleContractsService,
  ) {
    super();
  }
  getStatusCellLabel(cell: DXCell) {
    return cell.data.CurrentStatusLink.StatusId.Name;
  }

  getStatusCellDate(cell: DXCell) {
    return cell.data.CurrentStatusLink.Date;
  }

  getStatusCellClass(cell: DXCell) {
    let statusClass = 'text-white text-center'

    const statusCode = (<string>cell.data.CurrentStatusLink.StatusId.Code).toLowerCase().split('.')[1];
    if (statusCode == undefined) return;
    statusClass += ' ' + statusCode;
    return statusClass;
  }

  getStatusCellColor(cell: DXCell) {
    return cell.data.CurrentStatusLink.StatusId.Color;
  }
  public reload() {
    this.grid?.grid?.instance.refresh();
  }
}


